import { BidderCampaign } from '../../pages/bidder/campaigns/index/bidder.campaign';
import { EditBidderCampaign } from '../../pages/bidder/campaigns/edit/edit-bidder-campaign.page';
import routes from '../routes/index.routes';
import { CreateBidderCampaign } from '../../pages/bidder/campaigns/create/create-bidder-campaign.page';
import { DuplicateBidderCampaign } from '../../pages/bidder/campaigns/duplicate/duplicate-bidder-campaign.page';
import { BidderModels } from '../../pages/bidder/models/bidder-models.page';
import { EditBidderModel } from '../../pages/bidder/models/edit/edit-bidder-model.page';
import { BidderTraffic } from '../../pages/bidder/traffic/index/traffic.page';
import { CreateTraffic } from '../../pages/bidder/traffic/create/create-traffic.page';
import { EditTraffic } from '../../pages/bidder/traffic/edit/edit-traffic.page';

export const BidderRouter = [
	{
		path: routes.bidder.editModel(':modelName'),
		element: <EditBidderModel />,
	},
	{
		path: routes.bidder.models(),
		element: <BidderModels />,
	},
	{
		path: routes.bidder.editTraffic(':id'),
		element: <EditTraffic />,
	},
	{
		path: routes.bidder.createTraffic(),
		element: <CreateTraffic />,
	},
	{
		path: routes.bidder.traffic(),
		element: <BidderTraffic />,
	},
	{
		path: routes.bidder.campaigns(),
		element: <BidderCampaign />,
	},
	{
		path: routes.bidder.createCampaign(),
		element: <CreateBidderCampaign />,
	},
	{
		path: routes.bidder.editCampaign(':bidderCampaignId'),
		element: <EditBidderCampaign />,
	},
	{
		path: routes.bidder.duplicateCampaign(':bidderCampaignId'),
		element: <DuplicateBidderCampaign />,
	},
];
